<div class="filter">
  <div class="input-container">
    <input
      class="input-container__input"
      type="text"
      id="filter"
      [placeholder]="label()"
      [(ngModel)]="selectedState"
      (input)="updateFilter($event)"
    />

    <label for="filter" class="input-container__label">{{ label() }}</label>
  </div>
</div>

<ul class="droplist">
  @if (formService.filteredList().length) {
    @for (state of formService.filteredList(); track state.id) {
      <li class="droplist__item">
        <button
          (click)="selectOption(state)"
          class="droplist__button"
          [appBoldFontWeight]="formService.dropdownFilterSignal()"
          customClass="fw-bold"
        >
          {{ state.name }}
        </button>
      </li>
    }
  } @else {
    <li>
      <button
        class="droplist__button"
        [appBoldFontWeight]="formService.dropdownFilterSignal()"
        customClass="fw-bold"
      >
        No results
      </button>
    </li>
  }
</ul>
